









import {Component, Vue} from "vue-property-decorator";

@Component
export default class Breadcrumbs extends Vue {
    breadcrumbs: any = [];

    mounted() {
        this.breadcrumbs = this.$route.fullPath
            .split("/")
            .slice(1)
            .map((name, index) => {
                let route = this.$route.fullPath
                    .split("/")
                    .slice(0, index + 1)
                    .join("/");
                let resolved = this.$router.resolve(route).resolved;
                if (resolved.meta.breadcrumb != null && route !== "") {
                    return {
                        name: resolved.meta.breadcrumb,
                        route,
                    };
                }
            })
            .filter(e => e);
    }
}
